import {TextField, type TextFieldProps} from '@mui/material'
import {FC} from 'react'
import {Control, Controller, FieldValues, Path} from 'react-hook-form'

export const KilnConfigTextField: FC<TextFieldProps> = (props) => {
  return (
    <TextField
      variant="filled"
      size="small"
      InputProps={{
        sx: {
          background: '#fff',
          borderRadius: '4px'
        }
      }}
      {...props}
    />
  )
}

interface ControlledTextFieldProps<TField extends FieldValues> {
  control: Control<TField>
  formDataName: Path<TField>
  rules?: any
  label: string
  children?: React.ReactNode
  TextFieldProps?: TextFieldProps
  disabled?: boolean
}

export const ControlledTextField = <TField extends FieldValues>({
  control,
  formDataName,
  rules,
  label,
  children,
  TextFieldProps,
  disabled
}: ControlledTextFieldProps<TField>) => (
  <Controller
    control={control}
    name={formDataName}
    rules={rules}
    render={({field: {ref, value, onChange}, fieldState: {invalid, error}}) => {
      return (
        <KilnConfigTextField
          label={label}
          value={value}
          inputRef={ref}
          onChange={onChange}
          helperText={invalid && (error?.message ? error.message : 'Invalid value')}
          error={invalid}
          disabled={disabled}
          {...TextFieldProps}
        >
          {children}
        </KilnConfigTextField>
      )
    }}
  />
)
